export default __webpack_public_path__ + "static/media/culture.03d11a63.svg";